import { getCategories } from '@/utils/category';
const baseUrl = process.env.BASE_URL;

//基本配置
export const config = {
  width: 1920,
  height: 1080,
  scale: 1,
  mark: {
    show: false,
    text: 'avue数据大屏水印',
    fontSize: 20,
    textStyle: 'rgba(100,100,100,0.2)',
    degree: -20
  },
  backgroundImage: `${baseUrl}img/bg/bg1.png`,
  query: {}
};
// 颜色的配置
export const colorOption = {
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  column: [{
    label: '颜色1',
    prop: 'color1',
    type: 'color',
  }, {
    label: '渐变色',
    prop: 'color2',
    type: 'color',
  }, {
    label: '位置',
    prop: 'postion',
    type: 'number'
  }]
}

// 表格的列配置
export const tableOption = {
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  column: [{
    label: '名称',
    prop: 'label',
  }, {
    label: 'key值',
    prop: 'prop',
  }, {
    label: '宽度',
    prop: 'width',
  }, {
    label: '格式化',
    prop: 'format',
    type: 'cascader',
    dicData: getCategories()
  }]
}


//一些字典的配置
export const dicOption = {
  line: [{
    label: '线条',
    value: 'line'
  }, {
    label: '圆环',
    value: 'circle'
  }],
  fontWeight: [{
    label: 'normal',
    value: 'normal'
  }, {
    label: 'bold',
    value: 'bold'
  }, {
    label: 'bolder',
    value: 'bolder'
  }, {
    label: 'ligter',
    value: 'ligter'
  }],
  border: [{
    label: '无边框',
    value: ''
  }, {
    label: '内置图片',
    value: 'img'
  }, {
    label: '内置边框',
    value: 'border'
  }],
  textAlign: [{
    label: '居中',
    value: 'center'
  }, {
    label: '左对齐',
    value: 'left'
  }, {
    label: '右对齐',
    value: 'right'
  }],
  placement: [{
    label: '左上',
    value: 'lt'
  }, {
    label: '右上',
    value: 'rt'
  }, {
    label: '左下',
    value: 'lb'
  }, {
    label: '右下',
    value: 'rb'
  }],
  dataType: [{
    label: '静态数据',
    value: 0
  }, {
    label: '动态数据',
    value: 1
  }],
  interfaceWay: [{
    label: '手动填入',
    value: 0
  }, {
    label: '下拉选择',
    value: 1
  }],
  orientList: [{
    label: '竖排',
    value: 'vertical'
  }, {
    label: '横排',
    value: 'horizontal'
  }],
  orientType: [{
    label: '普通图例',
    value: 'plain'
  }, {
    label: '滚动图例',
    value: 'scroll'
  }],
  visualMapType: [{
    label: '连续型',
    value: 'continuous'
  }, {
    label: '分段型',
    value: 'piecewise'
  }],
  orientIcon: [{
    label: '矩形',
    value: 'roundRect'
  }, {
    label: '圆形',
    value: 'circle'
  }],
  dataMethod: [{
    label: 'POST',
    value: 'post'
  }, {
    label: 'GET',
    value: 'get'
  }],
  eventList: ['tabs2', 'pager', 'timeline'],
  dataList: ['common', 'wordcloud2', 'img', 'tabs2', 'maps', 'video', 'pie2', 'pictorialbar2', 'iframe', 'swiper', 'flop', 'flop2', 'bar2', 'line2', 'progress2', 'table', 'table2', 'gauge2', 'funnel2', 'scatter2', 'radar2', 'pager', 'rectangle', 'card', 'textscroll', 'cascade-tag', 'dataDisplay', 'table1', 'tier', 'diagram', 'timeline', 'treemap', 'text2', 'igraph-pickup', 'igraph-relation', 'ari-bubble', 'sunburst', 'sankey','img2','swiper2','goBack'],
  themeList: [{
    label: '默认配色',
    value: 'avue'
  }, {
    label: '紫色主题',
    value: 'macarons'
  }, {
    label: '绿色主题',
    value: 'wonderland'
  }],
  echart: ['common', 'maps', 'pictorialbar2', 'wordcloud2', 'scatter2', 'bar2', 'line2', 'pie2', 'gauge2', 'funnel2', 'radar2', 'rectangle', 'treemap', 'ari-bubble', 'sunburst', 'sankey'],
  barList: ['bar2', 'line2', 'ari-bubble'],
  titleList: ['bar2', 'pie2', 'line2', 'radar2', 'funnel2', 'ari-bubble', 'sunburst', 'sankey','swiper2'],
  labelList: ['bar2', 'line2', 'pie2', 'radar2', 'scatter2', 'sunburst', 'sankey','swiper2'],
  legendList: ['bar2', 'pie2', 'line2', 'radar2', 'funnel2', 'ari-bubble'],
  colorList: ['bar2', 'pie2', 'line2', 'gauge2', 'funnel2', 'scatter2', 'radar2', 'rectangle', 'tier', 'treemap', 'ari-bubble', 'sunburst', 'sankey'],
  tipList: ['bar2', 'pie2', 'line2', 'gauge2', 'funnel2', 'scatter2', 'radar2', 'ari-bubble'],
  postionList: ['bar2', 'line2', 'pictorialbar2', 'ari-bubble', 'sankey'],
  formatterList: ['bar2', 'maps', 'line2', 'pie2', 'gauge2', 'funnel2', 'scatter2', 'radar2'],
  clickFormatterList: ['maps'],
  labelFormatterList: ['bar2'],
  tabsTypeList: [{
    label: '选项卡',
    value: 'tabs',
  }, {
    label: '选择框',
    value: 'select',
  }],
  tabs2FlexList: [{
    label: '横向',
    value: 'row'
  }, {
    label: '纵向',
    value: 'column'
  }],
  mapType: [{
    label: '原生',
    value: 0
  }],
  target: [{
    label: '本窗口',
    value: '_self'
  }, {
    label: '新窗口',
    value: '_blank',
  }],
  swiperType: [{
    label: '普通',
    value: ''
  }, {
    label: '立体',
    value: 'card'
  }],
  swiperIndicator: [{
    label: '外部',
    value: 'indicator'
  }, {
    label: '不显示',
    value: 'none'
  }],
  format: [{
    label: '日期',
    value: 'yyyy-MM-dd'
  }, {
    label: '日期+时分',
    value: 'yyyy-MM-dd hh:mm'
  }, {
    label: '日期+时分秒',
    value: 'yyyy-MM-dd hh:mm:ss'
  }, {
    label: '日期(无年)',
    value: 'MM-dd'
  }, {
    label: '时分',
    value: 'hh:mm'
  }, {
    label: '时分秒',
    value: 'hh:mm:ss'
  }, {
    label: '星期',
    value: 'day'
  }]
}

export const categoryOption = getCategories();

function concat(prop, count, type, extend = [], defaults) {
  let list = [];
  for (let i = 1; i <= count; i++) {
    list.push({
      label: prop + i,
      value: `${baseUrl}img/${prop}/${prop}${i}.${extend.includes(i) ? defaults : type}`
    })
  }
  return list;
}
//加载图片素材库
export const imgOption = [
  concat('bg', 10, 'jpg', [1, 2, 3], 'png'),
  concat('border', 16, 'png'),
  concat('source', 260, 'svg', [1, 15, 16, 20, 239.240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260], 'png'),
  concat('banner', 10, 'png'),
  concat('fixes', 3, 'png'),
]